export const activeMenu = () => {
    const menu = document.getElementById('section-menu')
    if (menu) {
        const links = Array.from(menu.querySelectorAll('a'))
        links.map(link => {
            if (link.href === location.href || link.href === location.href.slice(0,-1)) link.classList.add('active-menu')
        })
    }
}

export const activeMenuLink = () => {
  const mainMenu = document.getElementById('main-menu')
  if (mainMenu) {
      const links = Array.from(mainMenu.querySelectorAll('a'))
      links.map(link => {
          if (link.href === location.href || link.href === location.href.slice(0,-1)) link.classList.add('active-menu--link')
      })
  }
}
